// Multivariate Dependencies
import React from 'react';
// Components
import { Label } from '../../Label';
import { Container } from '../../../common/styles/container';
import { StyledCheckbox } from '../styles/StyledCheckbox';
// Utils
import { getCheckboxIcon } from '../utils/getCheckboxIcon';
export var CheckboxStructure = function (_a) {
    var checked = _a.checked, size = _a.size, showLabel = _a.showLabel, label = _a.label, className = _a.className, disabled = _a.disabled, indeterminate = _a.indeterminate, onChange = _a.onChange;
    return (React.createElement(Label, { className: className, size: size, styleVariant: 'regular', "aria-label": showLabel && label ? undefined : label || 'Checkbox' },
        React.createElement("input", { type: 'checkbox', disabled: disabled, checked: checked, onChange: onChange }),
        React.createElement(StyledCheckbox, { as: 'span', checked: checked, indeterminate: indeterminate, size: size }, getCheckboxIcon(checked, indeterminate)),
        showLabel && (React.createElement(Container, { as: 'span', display: '-webkit-box', webkitLineClamp: '2', webkitBoxOrient: 'vertical', whiteSpace: 'break-spaces', wordBreak: 'break-all', alignSelf: 'center', fontSize: 'inherit', lineHeight: 'inherit', overflow: 'hidden' }, label))));
};
//# sourceMappingURL=CheckboxStructure.js.map